import { createSlice } from '@reduxjs/toolkit';

import { FacetState } from '../../types/facets';

// State Initialization
const initialState:any = {
	data: {}
};

const slice = createSlice({
	name: 'facet',
	initialState,
	reducers: {
		ADD_FACETS: (facet, action) => {
			action.payload.map((item: any) => {
				facet.data[`field_${item.id}_${item.label}`] = item;
			});
		},

		APPEND_FACET: (facet, action) => {
				facet.data[`field_${action.payload.id}_${action.payload.label}`] = action.payload;
		},
		EMPTY_FACETS: (facet, action) => {
		  facet.data = {};
		},
	},
});

export const { ADD_FACETS, EMPTY_FACETS, APPEND_FACET} = slice.actions;

export default slice.reducer;
